import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentCtx = createContext({ content: {}, loading: true, refresh: () => {} });

export function ContentProvider({ children }) {
    const [content, setContent] = useState({});
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/content");
            setContent(data || {});
        } catch {
            setContent({});
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <ContentCtx.Provider value={{ content, loading, refresh }}>{children}</ContentCtx.Provider>
    );
}

export function useContent() {
    return useContext(ContentCtx);
}
